<template>
	<div class="tracklist" ref="tracklist">
		<ul>
			<li v-for="track in playlist.tracks" :key="track.id">
				<span class="track-wrapper">
					<button
						type="button" 
						role="button" 
						:title="`lancer la lecture de ${track.name}`"
						:aria-pressed="isTrackActive(track.id)"
						:class="isTrackActiveClass(track.id)" 
						@click="setTrack(track.id)">
						<span class="track-title">{{ track.name }}</span>
						<span class="track-artist">{{ track.performer }}</span>
					</button>

					<span v-if="track.distribution" class="distributed-by">
						<a 
							v-if="isTrackOn(track, 'deezer')" class="platform deezer" target="_blank" 
							:href="track.distribution.deezer" 
							:aria-label="platformLinkLabel(track,'deezer')" 
							:title="platformLinkLabel(track,'deezer')">
							<i class="fa-brands fa-deezer"></i>
						</a>
						<a 
							v-if="isTrackOn(track, 'tidal')" class="platform tidal" target="_blank" 
							:href="track.distribution.tidal" 
							:aria-label="platformLinkLabel(track,'tidal')" 
							:title="platformLinkLabel(track,'tidal')">
							<i class="fa-brands fa-tidal"></i>
						</a>
						<a 
							v-if="isTrackOn(track, 'spotify')" class="platform spotify" target="_blank" 
							:href="track.distribution.spotify" 
							:aria-label="platformLinkLabel(track,'spotify')" 
							:title="platformLinkLabel(track,'spotify')">
							<i class="fa-brands fa-spotify"></i>
						</a>
						<a 
							v-if="isTrackOn(track, 'soundcloud')" class="platform soundcloud" target="_blank" 
							:href="track.distribution.soundcloud" 
							:aria-label="platformLinkLabel(track,'soundcloud')" 
							:title="platformLinkLabel(track,'soundcloud')">
							<i class="fa-brands fa-soundcloud"></i>
						</a>
						<a 
							v-if="isTrackOn(track, 'apple')" class="platform apple" target="_blank" 
							:href="track.distribution.apple"
							:aria-label="platformLinkLabel(track, 'apple')"
							:title="platformLinkLabel(track, 'apple')">
							<i class="fa-brands fa-apple"></i>
						</a>
						<a 
							v-if="isTrackOn(track, 'ytmusic')" class="platform ytmusic" target="_blank" 
							:href="track.distribution.ytmusic"
							:aria-label="platformLinkLabel(track, 'ytmusic')"
							:title="platformLinkLabel(track, 'ytmusic')">
							<i class="fa-brands fa-youtube"></i>
						</a>
					</span>
				</span>
			</li>
		</ul>
	</div>	
</template>
<script>

export default {
	props: {
		displaySpotify: {
			type: Boolean,
			default: false
		},
		playlist: {
			Type: Array,
			default: []
		},
		activeTrackId: {
			type: Number,
			default: 0
		}
	},
	emits: ['setActiveTrackById'],
	mounted() {
		this.adjustStylesheet();
	},
	methods: {
		isTrackActive(id) {
			return this.activeTrackId === id;
		},
		isTrackActiveClass(id) {
			return this.isTrackActive(id) ? "current" : null;
		},
		setTrack(id) {
			this.$emit("setActiveTrackById", id);
		},
		isTrackOn(track, platform) {
			if (platform === "spotify" && !this.displaySpotify) return false;
			return track.distribution && track.distribution[platform];
		},
		platformName(platform) {
			let name = "";
			switch(platform) {
				case "tidal":
					name = "Tidal";
					break;
				case "deezer":
					name = "Deezer";
					break;
				case "spotify":
					name = "Spotify";
					break;
				case "apple":
					name = "Apple Music";
					break;
				case "soundclound":
					name = "SoundCloud";
					break;
				case "ytmusic":
					name = "Youtube Music";
					break;
				default:
					return platform;
			}
			return name;
		},

		platformLinkLabel(track, platform) {
			const linkText = "Retrouver "+ track.name + " sur " + this.platformName(platform);
			return linkText;
		},

		adjustStylesheet() {
			this.$nextTick(() => {	

				let reservedHeight = 24;

				reservedHeight += this.$parent.$refs["main-header"].offsetHeight;
				reservedHeight += this.$parent.$refs.playlistMenu.$refs["playlists-selection"].offsetHeight;
				reservedHeight += this.$parent.$refs["main-footer"].offsetHeight;

				const viewportHeight = window.innerHeight;
				const tracklistHeight = viewportHeight - reservedHeight;
				
				this.$refs["tracklist"].style.height = tracklistHeight+"px";
			});
		}

	}
}
</script>
